
if ($('#footer').length) {
  if($(".ig").length){
    $(".instagram-widget>a").each(function(){
    $(".ig-feed").append('<div class="igfeed"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')})
  }
  $(".custom-footer > div ul, .custom-footer .news-item-widget, .custom-footer .doprapla, .custom-footer .banner").closest(".custom-footer > div").addClass("click-able");
  $('.custom-footer > div.click-able:not(.contact) h4').click( function() {
    $(this).closest(".custom-footer > div").toggleClass("open");
  });

  $('footer#footer').before($('footer#footer .footer-usp'))
  $('footer#footer').before($('footer#footer .ig'))
  $('footer#footer .contact-box').each(function(){
    $(this).find('.social-icon-list').appendTo('.social')
  })
}